import { inject, Injectable } from '@angular/core';
import { InjectableSuperclass } from '@sama/ng-core';
import { filter } from 'rxjs/operators';
import { TaskWorkspaceStore } from '../../../../h3ml/state/task-workspace-store';
import { KeyframeService } from './keyframe.service';
import { OutputKeyboardShortcutService } from './output-keyboard-shortcut.service';

@Injectable()
export class KeyframeKeyboardShortcutsService extends InjectableSuperclass {
  private taskWorkspaceStore = inject(TaskWorkspaceStore);
  private keyframeService = inject(KeyframeService);
  private keyboardShortcutService = inject(OutputKeyboardShortcutService);

  registerKeyboardShortcuts() {
    this.setUpToggleKeyframeShortcut();
    this.setUpCopyKeyframeShortcut();
  }

  private setUpToggleKeyframeShortcut() {
    this.subscribeTo(
      this.keyboardShortcutService
        .getEvent$('toggleKeyframe')
        .pipe(filter(() => !this.taskWorkspaceStore.state().readOnly)),
      () => {
        this.keyframeService.toggleKeyframesForSelectedShapes(
          'keyboard_shortcut',
        );
      },
    );
  }

  private setUpCopyKeyframeShortcut() {
    this.subscribeTo(
      this.keyboardShortcutService
        .getEvent$('copyLastKeyframe')
        .pipe(filter(() => !this.taskWorkspaceStore.state().readOnly)),
      () => {
        this.keyframeService.copyLastKeyframeForSelectedShapes(
          'keyboard_shortcut',
        );
      },
    );
  }
}
